<template>
    <tr
        v-if="isEditable"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <kgr-date-picker
                    v-model="editHoliday.date"
                />
            </div>
        </td>
        <td class="kgr-table__cell">
            <div class="form-widget without-label date-picker">
                <kgr-text-input
                    v-model.trim="editHoliday.description"
                    class="kgr-input"
                    rows="3"
                />
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <kgr-icon-edit
                :size="15"
                disabled
                class="kgr-table__action"
            />
            <kgr-icon-delete
                class="kgr-table__action"
                @click="$emit('remove')"
            />
        </td>
    </tr>
</template>

<script>
import DatePicker from '../../common/form/picker/DatePicker';
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import KindergartenHoliday from '../../../js/dto/KindergartenHoliday';
import TextInput from '../../common/form/text-input/TextInput';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-text-input': TextInput,
    },
    props: {
        holiday: {
            type: KindergartenHoliday,
            required: true
        },
        editHolidays: {
            type: Array,
            required: true
        },
    },
    computed: {
        isEditable() {
            return this.editIndex !== -1;
        },
        editIndex() {
            return this.editHolidays.map(editHoliday => editHoliday.id).indexOf(this.holiday.id);
        },
        editHoliday() {
            return this.editHolidays[this.editIndex];
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
